import { NgModule, ModuleWithProviders } from '@angular/core';
import { CourtesyMessagePipe } from './courtesy-message.pipe';
import { FormatOfficeNamePipe } from './format-office-name-pipe';
import { FormatPostalCodePipe } from './format-postal-code.pipe';
import { ImgixBlurPipe } from './imgix-blur.pipe';
import { ImgixSrcPipe } from './imgix-src.pipe';
import { IndexOfPipe } from './index-of.pipe';
import { ListingTypeAnalyticsTagPipe } from './listing-type-analytics-tag.pipe';
import { ObjectForPipe } from './object-for.pipe';
import { PureFunctionPipe } from './pure-function.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SecureLinkPipe } from './secure-link.pipe';
import { StaticPathPipe } from './static-path.pipe';

@NgModule({
  imports: [],
  declarations: [
    CourtesyMessagePipe,
    FormatOfficeNamePipe,
    FormatPostalCodePipe,
    ImgixSrcPipe,
    ImgixBlurPipe,
    ListingTypeAnalyticsTagPipe,
    SafeHtmlPipe,
    SecureLinkPipe,
    StaticPathPipe,
    ObjectForPipe,
    IndexOfPipe,
    PureFunctionPipe
  ],
  exports: [
    CourtesyMessagePipe,
    FormatOfficeNamePipe,
    FormatPostalCodePipe,
    ImgixSrcPipe,
    ImgixBlurPipe,
    ListingTypeAnalyticsTagPipe,
    SafeHtmlPipe,
    SecureLinkPipe,
    StaticPathPipe,
    ObjectForPipe,
    IndexOfPipe,
    PureFunctionPipe
  ]
})
export class SharedPipesModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedPipesModule,
      providers: [
        CourtesyMessagePipe,
        FormatOfficeNamePipe,
        FormatPostalCodePipe,
        ImgixSrcPipe,
        ImgixBlurPipe,
        ListingTypeAnalyticsTagPipe,
        SafeHtmlPipe,
        SecureLinkPipe,
        StaticPathPipe,
        ObjectForPipe,
        IndexOfPipe,
        PureFunctionPipe
      ]
    };
  }
}
